module.exports = __webpack_public_path__ + "img/arrow-down-left.b00cfb0e.svg";